/**
 * @desc 初始化受益部门数据
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/revenueDepartment/initialization`, {
      method: "GET",

      ...options,
    }),
  );
}
